import React from 'react';
import { Indicator, Root } from '@radix-ui/react-progress';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ProgressBar = styled(Indicator)`
  background: var(--progress-default);
  height: 100%;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  transition: 0.25s ease;
`;

// Note: Since we are on styled-components v4
// props are still forwarded because transient props ($)
// are available from v5. radix-ui is throwing a warning
// for the $background passed prop, so for now a [data-attribute]
// selector is used instead
const Bar = styled(Root)`
  height: 6px;
  min-width: 100px;
  border-radius: 100px;
  overflow: hidden;
  box-shadow: var(--basement);

  &[data-background='light'] {
    background: var(--progress-light);
  }

  &[data-background='dark'] {
    background: var(--progress-dark);
  }

  &[data-value='100'] {
    ${ProgressBar} {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
`;

function BaseProgress({
  max = 100,
  value = 0,
  background = 'light',
  ...props
}) {
  return (
    <Bar max={max} value={value} data-background={background} {...props}>
      <ProgressBar style={{ width: `${value}%` }} />
    </Bar>
  );
}
BaseProgress.propTypes = {
  background: PropTypes.oneOf(['dark', 'light']),
  value: PropTypes.number,
  max: PropTypes.number,
};

const Progress = styled(BaseProgress)``;

Progress.displayName = 'Progress';

export const SuccessProgress = styled(Progress)`
  > ${ProgressBar} {
    background: var(--progress-success);
  }
`;

SuccessProgress.displayName = 'SuccessProgress';

export const ErrorProgress = styled(Progress)`
  > ${ProgressBar} {
    background: var(--progress-error);
  }
`;

ErrorProgress.displayName = 'ErrorProgress';

export default Progress;
